<!--
 * @Author: your name
 * @Date: 2022-03-02 14:23:57
 * @LastEditTime: 2022-03-16 17:49:08
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /demander-manage/src/views/orderManagement/components/order/order.vue
-->
<template>
  <div class="orderLists">
    <div ref="orderLists" class="orderItem" style="position:relative;">
      <el-table
        v-if="!tableData.length"
        class="firstTable"
        :data="showData"
        :span-method="objectSpanMethod"
        border
        style="width: 100%; background: #f5f5f5;"
        :header-cell-style="{background:'#fff',color:'#666666',height:'54px',fontWeight:'400',border:'0'}"
      >
        <el-table-column :resizable="false" width="-1" />
        <el-table-column prop="goodsName" width="650" label="商品" align="center" :resizable="false" />
        <el-table-column prop="name" label="单价/数量" align="center" :resizable="false" />
        <el-table-column prop="amount1" label="收货人" align="center" :resizable="false" />
        <el-table-column prop="amount2" label="订单金额" align="center" :resizable="false" />
        <el-table-column
          v-if="orderStatus != 99"
          prop="amount3"
          label="订单状态"
          align="center"
          :resizable="false"
        />
        <el-table-column prop="amount3" label="订单操作" align="center" :resizable="false" />
      </el-table>
      <div v-for="(item,index) in tableData" :key="index" class="allTable">
        <el-table
          :class="index ? 'secondTable' : ''"
          :data="item.fdetails"
          :span-method="objectSpanMethod"
          border
          style="width: 100%; background: #f5f5f5;"
          :header-cell-style="{background:'#fff',color:'#666666',height:'54px',fontWeight:'400',border:'0'}"
          :cell-style="{fontSize:'14px',color:'#333'}"
          :cell-class-name="cellName"
          :row-class-name="rowName"
        >
          <el-table-column width="-1">
            <template slot-scope="scope">
              <div v-if="scope.row.row === true" class="order-title">
                <div class="title-left">
                  <div class="row-box">
                    <div><span>{{ item.fcreateTime }}</span></div>
                    <div>订单号：<span>{{ item.forderNo }}</span></div>
                    <div>下单人：<span>{{ item.fuserName }}</span></div>
                    <div class="d-deport">下单部门:
                      <el-tooltip  :disabled="!item.fdepartName"  class="item" effect="dark" :content="item.fdepartName||''" placement="top">
                                    
                                  <span>
                                  {{ item.fdepartName }}
                                  </span>
                       </el-tooltip> 
                  </div>
                    <div>订单备注：
                      <el-popover
                        v-if="item.fremark"
                        placement="top-start"
                        width="200"
                        trigger="click"
                        :content="item.fremark"
                      >
                        <i
                          slot="reference"
                          style="color:#F5783C;font-size: 14px;"
                          class="el-icon-warning-outline"
                        />
                      </el-popover>
                    </div>
                    <div
                      v-if="(item.forderStatus == 2 || item.forderStatus == 5) && !isRecycle"
                      class="dltIcon"
                      @click="operateOrder(item,1)"
                    >
                      <i class="el-icon-delete" />
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="650" label="商品" align="center" :resizable="false">
            <template slot-scope="scope">
              <div class="goods">
                <div class="goodsImg">
                  <el-image
                    style="width: 107px; height: 107px"
                    :src="scope.row.FStockImagePath"
                    :preview-src-list="[scope.row.FStockImagePath]"
                  >
                    <div slot="error" class="image-slot">
                      <!-- <i class="el-icon-picture-outline" /> -->
                      <img src="../../../../../assets/images/stockImg.jpg" alt="">
                    </div>
                  </el-image>
                </div>
                <div class="goodsInfo">
                  <div class="goodsName"><span
                    @click="toDetail(scope.row,item)"
                  >{{ scope.row.FStockName }}</span></div>
                  <div class="goodsExplain">
                    <div>
                      订货编码：
                      <span
                        v-if="scope.row.FStockShortCode"
                        class="code"
                        @click="copyCode(scope.row.FStockShortCode)"
                      >{{ scope.row.FStockShortCode | filterCode }}<i
                        class="el-icon-document-copy"
                      /></span>
                    </div>
                    <div>
                      需方编码：
                      <span
                        v-if="scope.row.FDemandStcokCode"
                        class="code"
                        @click="copyCode(scope.row.FDemandStcokCode)"
                      >{{ scope.row.FDemandStcokCode | filterCode }}<i
                        class="el-icon-document-copy"
                      /></span>
                    </div>
                    <div>
                      明细备注：
                      <el-popover
                        v-if="scope.row.fDetailRemark"
                        placement="top-start"
                        width="200"
                        trigger="click"
                        :content="scope.row.fDetailRemark"
                      >
                        <i
                          slot="reference"
                          style="color:#F5783C; "
                          class="el-icon-warning-outline"
                        />
                      </el-popover>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="单价/数量" align="center" :resizable="false" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="overText">
                <template v-if="FPriceShow">
                  ￥{{ scope.row.FTotalPrice }}
                </template>
                <div v-else id="noShowPrice" style="margin-right: 3px;">
                  <span style="margin:0;">￥</span>价格不可见
                </div>
                <span v-if="FPriceShow" style="margin:0 5px;">
                  X
                </span>
                <span>
                  {{ scope.row.FQuanty }}
                  <span v-if="scope.row.FMeasurement">{{ scope.row.FMeasurement }}</span>
                </span>
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="" label="收货人" align="center" :resizable="false">
            <template slot-scope="scope">
              <span style="color:#333;">
                {{ item.freceiver }}
              </span>
              <el-popover placement="bottom-start" width="465" trigger="click">
                <div class="deliveryInfo">
                  <p><span
                    style="margin-right:10px;"
                  >{{ item.freceiver }}</span>{{ item.freceiverPhoneNo }}
                  </p>
                  <p>{{ item.freceiverAddress }}</p>
                </div>
                <i
                  slot="reference"
                  style="color:#F5783C;font-size: 14px; "
                  class="el-icon-warning-outline"
                />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="订单金额" align="center" :resizable="false">
            <template slot-scope="scope">
              <div v-if="scope.$index == 1 && FPriceShow" v-html="filterMoney(item.ftotalAmount)" />
              <span v-else id="noShowPrice">
                <span style="margin:0;">￥</span>价格不可见
              </span>
            </template>
          </el-table-column>
          <el-table-column v-if="orderStatus != 99" label="订单状态" align="center" :resizable="false">
            <template slot-scope="scope">
              <span v-if="scope.$index == 1">
                <div class="status">{{ selectStatus[item.forderStatus] }}</div>
                <div
                  v-if="item.forderStatus == 3"
                  style="margin:0;position: relative;left: 50%;transform: translateX(-50%);margin-top: 8px;"
                  class="detail-btn"
                >提醒发货</div>
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="订单操作" :resizable="false">
            <template slot-scope="scope">
              <div v-if="scope.$index == 1" class="btn">
                <div class="detail-btn" @click="onTapOrderDetail(item.fid)">订单详情</div>
                <div v-if="isRecycle" class="detail-btn" @click="operateOrder(item,0)">还原订单</div>
                <template v-if="!isRecycle">
                  <div
                    v-if="item.forderStatus == 0"
                    class="detail-btn"
                    @click="() => { tipTitle = 2 , tipdia = true , selectOrder = item }"
                  >
                    确认交易
                  </div>
                  <div
                    v-if="item.afterList.length && item.forderStatus > 2 && item.forderStatus < 6"
                    class="detail-btn"
                    @click="applyAfterSales(true,item)"
                  >
                    申请售后
                  </div>
                  <div
                    v-if="item.forderStatus == 0 || item.forderStatus == 1"
                    class="detail-btn"
                    @click="() => { tipTitle = 1 , tipdia = true , selectOrder = item }"
                  >取消订单</div>
                  <div
                    v-if="true||item.forderStatus != 2 && item.forderStatus != 4 && scope.row.IsDirectoryPool"
                    class="detail-btn"
                    @click="allOperation(item)"
                  >再来一单</div>
                </template>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="fixed" :style="fixedWidthEl" @scroll="modelFixed">
      <div :style="'width:'+fixedWidth+'px'" />
    </div>

    <div class="confirmReceipt-dialog">
      <el-dialog title="确认收货" width="30%" center :visible.sync="confirmReceiptDialog" style="margin-top:20vh">
        <div class="dialog-content">
          <img src="@/assets/images/remove-err.png" alt="">
          <p class="confirmReceipt-tip">请确定是否收货?</p>
        </div>

        <span slot="footer" class="confirmReceipt-close">
          <el-button @click="confirmReceiptDialog = false">取 消</el-button>
          <el-button type="primary" @click="comfirmReceipt">确 定</el-button>
        </span>

      </el-dialog>
    </div>

    <tipdia
      :select-order="selectOrder"
      :tipdia="tipdia"
      :title="tipTitle"
      @onSearch="$emit('onSearch')"
      @closeTip="closeTip"
    />
    <tipsDia :tip-visible="tipVisible" :tip-type="tipType" @closeTips="tipVisible = false" @cfmTips="cfmTips" />
    <applyAfterSales
      :after-sales-visible="afterSalesVisible"
      :after-list="afterList"
      @closeTips="applyAfterSales"
    />
    <tips :tips-visible="tipsVisible" :tips-type="tipsType" @tipsSwitch="tipsSwitch" />
  </div>
</template>

<script>
import tipdia from '../tipdia/tipdia.vue'
import tipsDia from './tips.vue'
import request from '@/utils/request'
import applyAfterSales from './applyAfterSales.vue'
import tips from '../../../approvalQuery/tips.vue'
import service from '@/utils/request.js'
import {
  revedOrder,
  updateOrderStcokCode
} from '@/api/order.js'
export default {
  components: {
    tipdia,
    tipsDia,
    applyAfterSales,
    tips
  },
  filters: {
    filterCode(val) {
      if (val) return val.slice(0, 9)
    }
  },
  // 接受父组件的值
  props: {
    orderStatus: {
      type: String,
      default: '0'
    },
    tableData: {
      type: Array,
      default: () => []
    },
    isRecycle: {
      type: Boolean
    }
  },
  data() {
    return {
      tipsVisible: false,
      tipsType: 0,
      afterList: [],
      afterSalesVisible: false,
      operateItem: null,
      tipType: 0,
      tipVisible: false,
      changeRow: null,
      changeCode: null,
      selectCode: '',
      selectOrder: {},
      tipTitle: 1,
      tipdia: false,
      details: false,
      confirmReceiptDialog: false, // 删除地址弹窗
      showData: [],
      selectStatus: [
        '待付款',
        '待接单',
        '已取消',
        '待发货',
        '待收货',
        '已完成'
      ],
      FPriceShow: 0,
      fixedWidth: 0,
      fixedWidthEl: 0
    }
  },
  computed: {
    // 当前页操作权限
    rols() {
      const setting = this.$store.getters.pageSetting('订单管理')
      return function(val) {
        if (typeof setting === 'boolean') return true
        return setting.indexOf(val) > -1
      }
    }
  },
  watch: {
    tableData: {
      handler(newValue, oldValue) {
        this.$forceUpdate()
        this.$nextTick(this.resizeWidth)
      }
    },
    orderStatus: {
      handler(newValue, oldValue) {
        var that = this
        that.orderStatus = newValue
        this.tableData.forEach(item => {
          this.$set(item, 'status', newValue)
        })
      }
    }
  },
  created() {
    const userInfor = localStorage.getItem('userInfo')
    userInfor && (this.FPriceShow = JSON.parse(userInfor).FPriceShow)
    this.listenerFunction()
    // console.log(this.$route)
  },
  mounted() {
    window.onresize = this.resizeWidth
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.listenerFunction)
  },
  methods: {
    tipsSwitch(val) {
      if (val) {
        const loadingObj = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0,0,0,0.5)',
          target: document.querySelector('.submit-test-dialog')
        })
        const shoppingCartList = []
        this.selectOrder.fdetails.forEach(t => {
          if (!t.row) {
            shoppingCartList.push({
              fstockName: t.FStockName,
              fmallstoreStockId: t.fmallstoreStockId,
              fQuanty: t.FQuanty
            })
          }
        })
        const data = new URLSearchParams()
        data.append('jsonobj', JSON.stringify({
          shoppingCartList
        }))
        service({
          url: '/mall/stockmanage/mallstorestock/addShoppingCart',
          method: 'post',
          data
        })
          .then(res => {
            if (res.result) {
              this.$message.success(res.msg)
              this.tipsVisible = false
              loadingObj.close()
              //   this.$parent.$parent.$refs.rightNav.getComput()
              console.log(this)
            } else {
              loadingObj.close()
              this.$message.error(res.msg)
            }
          })
          .catch(() => {
            loadingObj.close()
          })
      } else {
        this.tipsVisible = false
      }
    },
    allOperation(item) {
      this.selectOrder = item
      this.tipsVisible = true
    },
    modelFixed(e) {
      const left = e.target.scrollLeft
      if (this.$refs.orderLists) this.$refs.orderLists.scrollLeft = left
      // console.log(e)
      if (document.getElementById('el-table__body_efefef')) {
        document.getElementById('el-table__body_efefef')
          .scrollLeft = left
      }
    },
    resizeWidth() {
      this.$nextTick(() => {
        const el = document.querySelector('.orderItem .el-table__body-wrapper')
        if (el) {
          // console.log(el.offsetWidth)
          this.fixedWidth = el.offsetWidth
        }
        // console.dir(this.$refs.orderLists)
        this.fixedWidthEl = {
          width: this.$refs.orderLists.offsetWidth + 'px',
          left: 235 + 'px'
        }
        const els = document.getElementById('el-table__body_efefef')
        if (els) {
          if (els.style) {
            els.style.width = this.$refs.orderLists.offsetWidth + 'px'
          } else {
            els.style.width = 'auto'
          }
        }
        this.fixedPosition()
      })
    },
    fixedPosition() {
      const html = document.firstElementChild
      const h = html.scrollTop + html.clientHeight
      let obj = {
        width: this.$refs.orderLists.offsetWidth + 'px',
        left: 235 + 'px'

      }
      if (html.scrollHeight - h < 100) {
        obj = {
          position: 'initial',
          'margin-top': '-11px'
        }
      }
      this.fixedWidthEl = obj
    },
    applyAfterSales(b, item) {
      if (item) this.afterList = item.afterList
      this.afterSalesVisible = b
    },
    cfmTips(type) {
      const url = type
        ? '/mall/mallmanage/demandOrder/deleteOrder'
        : '/mall/mallmanage/demandOrder/cancalDeleteOrder'
      request({
        url: `${url}?id=${this.operateItem.fid}`,
        method: 'post'
      })
        .then(res => {
          const msgType = res.result ? 'success' : 'error'
          this.$message({
            type: msgType,
            message: res.msg
          })
          res.result && (this.tipVisible = false, this.$parent.onSearch())
        })
    },
    operateOrder(t, i) {
      this.operateItem = t
      this.tipType = i
      this.tipVisible = true
    },
    cellName({
      row,
      column,
      rowIndex,
      columnIndex
    }) {
      if (column.label != '单价/数量') {
        return 'noBorder'
      }
    },
    rowName({
      row,
      rowIndex
    }) {
      if (!rowIndex) return 'noHover'
    },
    copyCode(val) {
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', val)
      input.setAttribute('create', 1)
      input.select()
      document.execCommand('Copy')
      var list = document.getElementsByTagName('input')
      var inputList = Array.prototype.slice.call(list)
      inputList.forEach((item) => {
        if (item.getAttribute('create')) document.body.removeChild(item)
      })
    },
    filterMoney(val) {
      const m = (val || 0).toFixed(2)
      const str =
                    `<span style='font-size:12px;font-weight:bold;color:#EC212D;'>￥<span style='font-size:16px;'>${m.split('.')[0]}</span>.${m.split('.')[1]}</span>`
      return str
    },
    listenerFunction(e) {
      document.addEventListener('scroll', this.handleScroll, true)
    },
    // 监听滚动条,固定表头
    handleScroll() {
      if (!this.details && this.$route.path === '/order/orderManagement') {
        const yOffSet = window.pageYOffset
        const headerOrg = this.$refs.orderLists.getElementsByClassName('el-table__header-wrapper')
        const header = this.$refs.orderLists.getElementsByClassName('el-table__header-wrapper')[0]
          .cloneNode()
        // console.log( headerOrg)
        headerOrg[0].childNodes.forEach(item => header.append(item.cloneNode(true)))

        this.fixedPosition()
        // const table = this.$refs.orderLists.getElementsByClassName('el-table__body-wrapper')
        if (yOffSet > 333) {
          if (document.getElementById('el-table__body_efefef')) return
          document.getElementById('el-table__body_efefef') && document.getElementById(
            'el-table__body_efefef').remove()
          console.log('追加')
          header.setAttribute('id', 'el-table__body_efefef')
          header.setAttribute('style', 'position:fixed;top:2px;z-index:999;height:55px;overflow:hidden;')
          headerOrg[0].parentNode.append(header)
          this.resizeWidth()
        }
        if (yOffSet < 330) {
          document.getElementById('el-table__body_efefef') && document.getElementById(
            'el-table__body_efefef').remove()
          header.removeAttribute('style')
        }
      }
    },
    toDetail(row, item) {
      if (!row.IsDirectoryPool) return
      if (row.FShelfed === 0) {
        return this.$message.error('该商品未上架')
      }
      if (row.FShelfed === 2) {
        return this.$message.error('该商品已下架')
      }
      if (!row.isChange) {
        const path = this.$router.resolve({
          path: '/store/details',
          query: {
            mallstorestockFId: row.FStoreStockID,
            shopid: item.fmallStoreId
          }
        })
        window.open(path.href, '_blank')
      }
    },
    confirmChangeCode() {
      const params = new URLSearchParams()
      params.append('id', this.changeRow.fdetailID)
      params.append('FDemandStcokCode', this.selectCode)
      updateOrderStcokCode(params)
        .then(res => {
          if (res.result) {
            this.$message.success(res.msg)
            this.changeRow.FDemandStcokCode = this.selectCode
            this.changeRow.isChange = false
            this.selectCode = ''
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    tochangeCode(row) {
      this.changeRow = row
      this.selectCode = row.FDemandStcokCode
      this.changeCode = row.fdetailID
      row.isChange = true
      this.$nextTick(() => {
        document.getElementById(row.fdetailID).focus()
      })
    },
    returnPrice(item) {
      let n = 0
      item.fdetails.forEach((t, i) => {
        if (i !== 0) {
          n += Number(t.FReturnAmount)
        }
      })
      return `￥${n}`
    },
    comfirmReceipt() {
      const params = new URLSearchParams()
      params.append('id', this.selectOrder.fid)
      revedOrder(params)
        .then(res => {
          if (res.result) {
            this.$message.success(res.msg)
            this.confirmReceiptDialog = false
            this.$parent.$parent.$parent.$refs.rightNav.comput.FWRQuanty--
            this.$emit('onSearch')
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    closeTip() {
      this.tipdia = false
    },
    confirmReceipt(item) {
      this.confirmReceiptDialog = true
      this.selectOrder = item
    },
    objectSpanMethod({
      row,
      column,
      rowIndex,
      columnIndex
    }) {
      if (columnIndex > 2) {
        return {
          rowspan: 99,
          colspan: 1
        }
      }
      if (rowIndex === 0) {
        if (columnIndex === 0) {
          return [1, 9]
        } else {
          return [0, 0]
        }
      }
    },
    // 点击查看详情
    onTapOrderDetail(id) {
      this.details = true
      this.$emit('onTapOrderDetail', this.details, id)
    },
    // 前往订单评价
    onTapOrderEvaluate(row, id, status) {
      const obj = {
        id,
        detailId: row.fdetailID,
        stock: row.FStockName,
        path: row.FStockImagePath
      }
      this.$router.push({
        path: '/orderManagement/evaluate',
        redirect: '/',
        query: {
          stockObj: JSON.stringify(obj),
          orderStatus: this.orderStatus
        }
      })
    },
    // 申请售后
    onTapToService(row, orderStatus) {
      //   if (row.FJoinType == 3) return this.$message.warning('供方为直销部门，请联系平台取消订单！')
      //   const routeUrl = this.$router.resolve({
      //     path: '/service',
      //     redirect: '/',
      //     query: {
      //       stockInfo: JSON.stringify(row),
      //       orderStatus: this.orderStatus
      //     }
      //   })
      //   window.open(routeUrl.href, '_blank')
      this.$router.push({
        path: '/service',
        redirect: '/',
        query: {
          stockInfo: JSON.stringify(row),
          orderStatus: this.orderStatus
        }
      })
      this.afterSalesVisible = false
    }
  }
}
</script>

<style lang="scss">
    .fixed {
        position: fixed;
        width: 100%;
        height: 20px;
        background: transparent;
        left: 0;
        overflow-x: overlay;
        z-index: 9;
        bottom: 0;

        &>div {
            width: 2000px;
        }
    }

    .deliveryInfo {
        p {
            // height: 30px;
            line-height: 30px;
            color: #333333;
            font-weight: bold;
        }

        .address {
            font-weight: 400;
            margin-bottom: 0;
        }
    }

    .firstTable {
        .el-table__body-wrapper {
            display: none;
        }
    }

    .secondTable {
        .el-table__header-wrapper {
            display: none;
        }
    }

    .orderLists {
        width: 100%;

        // transform: scale(1);
        .el-table__header-wrapper {
            margin-bottom: 10px;
        }

        .firstTable .el-table__header-wrapper {
            margin-bottom: 0;
        }

        .allTable {
            .noBorder {
                border-right: 0;
            }

            .noHover .el-table__cell {
                padding: 0;

                &:hover {
                    background-color: #fff;
                }
            }
        }

        #noShowPrice {
            // display: inline-block;
            text-align: center;
            font-size: 14px;
            color: #ec2631;
            font-weight: 400;

            span {
                font-size: 12px;
            }
        }
    }

    .service-btn {
        width: 70px;
        height: 28px;
        line-height: 28px;
        background: #FFFFFF;
        border: 1px solid #CDCDCD;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
        cursor: pointer
    }

    .evaluate {
        cursor: pointer;
        width: 55px;
        height: 28px;
        line-height: 28px;
        background: #EC212D;
        color: #fff;
        text-align: center;
        border-radius: 5%;
    }

    .detail-btn {
        width: 68px;
        height: 26px;
        line-height: 26px;
        font-size: 14px;
        font-weight: 400;
        cursor: pointer;

        &:hover {
            color: #EC212D;
        }
    }

    .no-detail-btn {
        border: 1px solid #999;
        color: #333;
    }

    .orderItem {
        width: 100%;
        margin: 10px 0px;
        background: #f5f5f5;
        overflow-x: hidden;

        .allTable {
            overflow: initial;

            .el-table {
                overflow: initial;
                width: calc(100% - 2px) !important;

                tbody tr:hover > td {
                    background-color: transparent
                }

                .el-table__body {
                    overflow: hidden;
                }

                .el-table__header-wrapper {
                    width: fit-content;
                }

                .el-table__body-wrapper {
                    width: fit-content;
                    overflow: initial;
                }
            }
        }

        .el-table__body-wrapper {
            margin-bottom: 10px;
        }

        .order-title {
            padding: 0 10px;
            width: 100%;
            height: auto;
            line-height: 40px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 12px;
            font-weight: 400;
            color: #333333;
            box-sizing: border-box;

            .title-left {
                width: 100%;
                align-items: center;

                div {
                    margin-right: 20px;
                }

                .row-box {
                    display: flex;
                    position: relative;
                    margin-right: 0;
                    flex-wrap: wrap;
                    .dltIcon {
                        cursor: pointer;
                        position: absolute;
                        font-size: 17px;
                        right: 0;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 24px;
                        height: 24px;
                        margin-right: 0;
                        border-radius: 2px;
                        line-height: 24px;
                        text-align: center;
                        color: red;

                        &:hover {
                            background-color: #F3F3F3;
                        }
                    }

                    div {
                        line-height: 40px;
                    }

                    span {
                        display: inline-block;
                        min-width: 180px;
                    }
                    .d-deport{
                        flex: none;
                        display: flex;
                         white-space: nowrap;
                         span{
                          white-space: nowrap;
                          /* display: block; */
                          width: 100px;
                          min-width: 100px;
                          flex: none;
                          margin: auto 0;
                          overflow: hidden;
                          text-overflow: ellipsis;
                         }
                    }
                }
            }

            .title-right {
                width: 50px;
                display: inline-block;
                line-height: 30px;
                float: right;
                // width: 10% !important;
                cursor: pointer;
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                text-decoration: underline;
                color: rgb(236, 33, 45);

            }
        }
        .overText {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .price,
        .number,
        .goodsOperate,
        .money,
        .status,
        .orderOperate,
        .operate-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            font-weight: 400;
            color: #333333;
        }

        .remark {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #333333;
        }

        .service {
            width: 62px;
            height: 22px;
            background: #FFFFFF;
            border: 1px solid #CDCDCD;
            border-radius: 2px;
        }

        .btn {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

        }

        .goods {
            min-width: 550px;
            display: flex;
            box-sizing: border-box;
            padding: 10px 20px 10px 10px;

            .goodsImg {
                width: 107px;
                height: 106px;
                margin-right: 13px;

                img {
                    width: 107px;
                    height: 107px;
                }

                .el-image {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: #f5f7fa;
                }
                .image-slot {
                    width: 107px;
                    height: 107px;
                }
            }

            .goodsInfo {
                color: rgb(103, 107, 124);
                flex: 1;

                .goodsName {
                    text-align: left;
                    height: 47px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #333333;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;

                    span {
                        cursor: pointer;
                    }

                    span:hover {
                        text-decoration: underline;
                        color: #EC212D;
                    }
                }

                .goodsExplain {
                    width: 100%;
                    height: 20px;
                    text-align: left;
                    font-size: 12px;
                    font-weight: 400;
                    color: #777;
                    box-sizing: border-box;
                    padding: 0 30px 0 0px;

                    >div {
                        height: 22px;
                    }

                    .el-icon-edit {
                        font-size: 18px;
                        cursor: pointer;
                    }

                    .code {
                        cursor: pointer;
                    }

                }
            }
        }

    }

    .confirmReceipt-dialog {
        .dialog-content {
            width: 100%;
            height: 60px;
            margin-top: 23px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
        }

        img {
            width: 102px;
            height: 66px;

        }

        .confirmReceipt-tip {
            margin: 9px 0 22px 0;
            font-size: 18px;
            color: #333;
        }

        .confirmReceipt-close button:first-child {
            color: #EC212D;
            background-color: #fff;
            border: 1px solid #EC212D;
            width: 135px;
            height: 30px;
            line-height: 30px;
            padding: 0;
        }

        .confirmReceipt-close button:last-child {
            color: #fff;
            background-color: #EC212D;
            border: 1px solid #EC212D;
            width: 135px;
            height: 30px;
            line-height: 30px;
            padding: 0;
        }
    }

    #el-table__body_efefef {
        .is-leaf {
            background-color: #efefef !important;
        }
    }
</style>>
